import { useState } from "react";
import { Card, CardContent, CardHeader } from "components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "components/ui/tabs";
import ContentImport from "pages/Admin/ContentImport";
import ContentExport from "pages/Admin/ContentExport";

type TabValue = "import" | "export";

const CourseData: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabValue>("import");

  return (
    <Card disableAnimation maxWidth="none">
      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as TabValue)} className="w-full">
        <CardHeader>
          <TabsList className="bg-transparent justify-start px-2">
            <TabsTrigger value="import" className="px-2">
              Import
            </TabsTrigger>
            <TabsTrigger value="export" className="px-2">
              Export
            </TabsTrigger>
          </TabsList>
        </CardHeader>
      </Tabs>

      <CardContent variant="form">
        <div className="mb-6 rounded-xl border border-sky-200 bg-sky-50 p-4 text-sm text-slate-700">
          <p className="font-semibold text-slate-900">Chapters and prerequisites stay with this course</p>
          <p className="mt-1">
            CSV exports include Course Key, Course Version, Course Chapters, Chapter Key, and Course
            Prerequisites. CSV and Drive imports read the same fields. Missing or blank chapter and
            prerequisite columns preserve existing settings; an explicit [] clears that structure.
            Import prerequisite courses first, using their exact key and version from Course Builder.
            Legacy imports retain chapter placement for surviving modules and add new modules ungrouped.
          </p>
        </div>
        <div className={activeTab !== "import" ? "hidden" : undefined}>
          <ContentImport />
        </div>
        <div className={activeTab !== "export" ? "hidden" : undefined}>
          <ContentExport active={activeTab === "export"} />
        </div>
      </CardContent>
    </Card>
  );
};

export default CourseData;
